import React, { useEffect } from 'react';
import { Form, Input, Modal, Radio } from '@maxtropy/components';
import { apiV2PeriodCopyPost } from '@maxtropy/device-customer-apis-v2';
import { PeriodItem } from '..';
import { isNil } from 'lodash-es';

interface Props {
  period: PeriodItem;
  modalVisible?: boolean;
  setModalVisible: (v: boolean) => void;
  forceUpdate?: () => void;
}
const CopyPeriodModal: React.FC<Props> = ({ period, modalVisible, setModalVisible, forceUpdate }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (period) {
      form.setFieldValue('name', period.name + '-复制');
    }
  }, [period]);

  const onOk = () => {
    if (isNil(period.id)) return;
    form.validateFields().then(values => {
      apiV2PeriodCopyPost({ name: values.name, copyReverse: values.copyReverse, id: period.id }).then(res => {
        setModalVisible(false);
        forceUpdate?.();
      });
    });
  };

  const onCancel = () => {
    form.resetFields();
    setModalVisible?.(false);
  };

  return (
    <Modal
      contentClassName="modal-form-content"
      open={modalVisible}
      title="复制"
      onCancel={onCancel}
      onOk={onOk}
      destroyOnClose
    >
      <Form form={form} initialValues={{ copyReverse: false }}>
        <Form.Item label="数据查询时段名称" name="name" rules={[{ required: true, min: 2, max: 30 }]}>
          <Input placeholder="请输入" allowClear />
        </Form.Item>
        <Form.Item label="按日期范围24小时反向生成" name="copyReverse" rules={[{ required: true }]}>
          <Radio.Group>
            <Radio value={false}>否</Radio>
            <Radio value={true}>是</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CopyPeriodModal;
